export default [
    {
        path: 'order-dashboard',
        meta: { 
            label: 'Order Dashboard', 
            permission: 'show_reports_order_dashboard',
            icon: 'dashboard',
            group: 'Order Reports'
        },
        name: 'order-dashboard',
        component: () => import('./../../views/orderReport/OrderDashboard.vue'),
    },
    {
        path: 'order-statistics',
        meta: { 
            label: 'Order Statistics', 
            permission: 'show_reports_order_statistics',
            icon: 'statistics',
            group: 'Order Reports'
        },
        name: 'order-statistics',
        component: () => import('./../../views/orderReport/OrderStatisticsReport.vue'),
    },
    {
        path: 'order-summary',
        meta: { 
            label: 'Order Summary Report', 
            permission: 'show_reports_order_summary',
            icon: 'summary',
            group: 'Order Reports'
        },
        name: 'order-summary',
        component: () => import('./../../views/orderReport/OrderSummaryReport.vue'),
    }
    , {
        path: 'order-details',
        meta: { 
            label: 'Order Details Report', 
            permission: 'show_reports_order_details',
            icon: 'details',
            group: 'Order Reports'
        },
        name: 'order-details',
        component: () => import('./../../views/orderReport/OrdersCollections.vue'),
    }
];